import dayjs from 'dayjs'

/**
 * * Program Name Switch
 * @param officeValue 사업소코드
 * @return Program Name
 */
export const programNameHandler = (officeValue: string) => {
  switch (officeValue) {
    case '4700':
    case '5701':
    case 'H101':
    case 'A600':
    case '7001':
    case 'D101':
    case '2601':
    case '2602':
      return 'BLUEWATER'
    case '1900':
    case '7601':
    case '7602':
    case 'A800':
      return 'SAEOL1'
    case '1701':
    case '5400':
    case 'C900':
    case 'Z200':
      return 'SAEOL'
    case 'Z101':
    case 'Z102':
    case '3801':
    case '8001':
    case 'Z700':
    case 'C100':
    case '0801':
    case '7900':
    case '5800':
    case 'B700':
      return 'WIMS'
    default:
      return ''
  }
}

/**
 * * DatePicker Input Format Func
 * @param programName 요금부과 프로그램 이름
 * @param serverName 서버 이름
 * @returns datePicker format
 */
export const datePickerInputFormat = (programName: string, officeValue: string) => {
  switch (programName) {
    case 'WIMS':
      switch (officeValue) {
        case '3801':
        case '8601':
        case '0801':
        case '7900':
        case '5800':
          return 'YYYY년 MM월 DD일'
        default:
          return 'YYYY년 MM월'
      }
    case 'BLUEWATER':
    case 'SAEOL1':
    case 'SAEOL':
    case 'CREBIZ':
      return 'YYYY년 MM월'
    default:
      return 'YYYY년 MM월'
  }
}

/**
 * * DatePicker Input Format Func
 * @param programName 요금부과 프로그램 이름
 * @param serverName 서버 이름
 * @returns datePicker format
 */
export const onChangeHandler = (newValue: any, programName: string, officeValue: string) => {
  switch (programName) {
    case 'WIMS':
      switch (officeValue) {
        case '3801':
        case '8601':
        case '0801':
        case '7900':
        case '5800':
          return dayjs(newValue).endOf('month').format('YYYYMMDD')
        default:
          return dayjs(newValue).format('YYYYMM')
      }
    case 'BLUEWATER':
    case 'SAEOL1':
    case 'SAEOL':
    case 'CREBIZ':
      return dayjs(newValue).format('YYYYMM')
    default:
      return dayjs(newValue).format('YYYYMMDDHH')
  }
}
